import { render, staticRenderFns } from "./ConnectTenant.vue?vue&type=template&id=38816588&scoped=true"
import script from "./ConnectTenant.vue?vue&type=script&lang=ts"
export * from "./ConnectTenant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38816588",
  null
  
)

export default component.exports